<template>
    <div>
        <live-klass-write-link v-for="writeLayout in writeLayouts" :key="`liveKlassComp${writeLayout}`"
                               :writeLayout="writeLayout" :liveklassData="liveklassData"
                               :thumbnailFiles="thumbnailFiles"></live-klass-write-link>
    </div>
</template>

<script>
import util from "@/mixins/util";
import alertMixins from "@/mixins/alertMixins";
import elFileMixins from "@/mixins/elFileMixins";
import EventBus from "@/utils/event-bus";
import DeleteClass from "@/mixins/deleteClass";
import LiveKlassWriteLink from "@/components/liveklass/LiveKlassWriteLink";
import liveklassUtil from "@/components/liveklass/liveklassUtil";
import liveklassValidator from "@/mixins/validators/liveklassValidator";

export default {
    name: "LiveKlassWriteComponent",
    mixins: [alertMixins, elFileMixins, liveklassUtil, liveklassValidator],
    components: {LiveKlassWriteLink},
    provide() {
        return {
            liveKlassWriteSetData: this.setData,
            liveKlassResetPenalty: this.runResetPenaltyConfirm
        }
    },
    inject: ['changeLoading'],
    props: {
        liveklassType: {default: ''},
        liveKlassKey: {default: 0},
    },
    data() {
        return {
            writeLayouts: [],
            getFunc: '',
            detailApiParamsSet: {},
            getDetailParamsKey: 'id',
            writeFunc: '',
            writeApiParamSet: {},
            parsingData: {},
            directUrl: '',
            directType: '',
            keyName: '',
            writeSuccessType: 1,
            writeFailTypes: {},
            fileType: '',


            deleteFunc: '',
            deleteApiParamsSet: {},
            deleteSuccessType: 1,
            deleteFailTypes: {},
            deleteAlertText: '',
            deleteSuccessAlertText: '',
            DeleteClass: null,

            liveklassData: {},
            thumbnailFiles: [],
        }
    },
    created() {
        this.initFilterConfig();
        if (this.liveKlassKey === 0) {
            this.initTemplateConfig();
        } else {
            this.getLiveKlass();
        }
    },
    mounted() {
        EventBus.$on('writeLiveKlass', this.writeLiveKlass)
        EventBus.$on('checkKoinChange', this.checkKoinChange)
        EventBus.$on('runLiveKlassWriteDelete', this.runDeleteConfirm)
    },
    beforeDestroy() {
        EventBus.$off('writeLiveKlass')
        EventBus.$off('checkKoinChange')
        EventBus.$off('runLiveKlassWriteDelete')

    },
    destroyed() {
    },
    computed: {},
    methods: {
        setData(type, value) {
            this[type] = value;
            if(type == 'koin'){
                this[type] = value*1;
            }
        },
        initTemplateConfig() {
            let config = this.returnLiveKlassConfig(this.liveklassType);
            this.writeLayouts = config.writeLayouts;
        },
        initFilterConfig() {
            let config = this.returnLiveKlassConfig(this.liveklassType);
            this.getFunc = config.getFunc;
            this.detailApiParamsSet = config.detailApiParamsSet;
            this.getDetailParamsKey = config.getDetailParamsKey ? config.getDetailParamsKey : this.getDetailParamsKey;
            this.writeFunc = config.writeFunc;
            this.writeApiParamSet = config.writeApiParamSet;
            this.parsingData = config.parsingData;
            this.directUrl = config.directUrl;
            this.directType = config.directType;
            this.fileType = config.fileType;
            this.keyName = config.keyName;
            this.writeSuccessType = config.writeSuccessType;
            this.writeFailTypes = config.writeFailTypes;


            this.deleteFunc = config.deleteFunc;
            this.deleteApiParamsSet = config.deleteApiParamsSet;
            this.deleteSuccessType = config.deleteSuccessType;
            this.deleteFailTypes = config.deleteFailTypes;
            this.deleteAlertText = config.deleteAlertText
            this.deleteSuccessAlertText = config.deleteSuccessAlertText;

            this.newDeleteClass();
        },
        newDeleteClass() {
            if (!util.isEmpty(this.deleteFunc)) {
                let deleteOptions = {
                    func: this.$api.$liveklass[this.deleteFunc],
                    apiParamSet: this.deleteApiParamsSet,
                    keyName: this.keyName,
                    successType: this.deleteSuccessType,
                    errorTypes: this.deleteFailTypes,
                    afterFunc: this.deleteAfterFunc,
                }
                this.DeleteClass = new DeleteClass(deleteOptions);
            }
        },
        getLiveKlass() {
            let params = JSON.parse(JSON.stringify(this.detailApiParamsSet));
            if (this.liveKlassKey != 0) {
                params[this.getDetailParamsKey] = this.liveKlassKey;
            }
            this.$api.$liveklass[this.getFunc](params).then(res => res.Data.Result).then(async res => {
                if (res.Info.type != 1 || res.List.length === 0) {
                    this.createAlert({
                        title: '',
                        content: '데이터를 불러올 수 없습니다.',
                        btnText: '확인',
                        hide: () => {
                            this.$router.back();
                        }
                    });
                    return;
                }
                params = {
                    a_container_id: this.liveKlassKey,
                    a_container_type: this.fileType,
                }
                await this.$api.$file.getFile(params).then(res => res.Data.Result).then(res => {
                    if (!util.isEmpty(res.List) && res.Info.type == 1) {
                        this.thumbnailFiles = res.List;
                    }
                })
                this.liveklassData = res.List[0];
                console.log(res.List[0]);
                this.initTemplateConfig();
            })
        },
        checkKoinChange(){
            if((this.liveklassData.lk_koin_price*1) != (this.koin*1)){
                this.createConfirm({
                    content: "저장된 시점 이후부터 변동된 가격으로 앱에 노출됩니다.<br> 이미 구매한 유저는 영향을 받지 않습니다.",
                    confirm: () => {
                        this.writeLiveKlass();
                    }
                })
            }else {
                this.writeLiveKlass();
            }

        },
        writeLiveKlass() {
            let dataKeys = Object.keys(this.parsingData);
            if (!util.isEmpty(this.fileType)) {
                dataKeys.push('files')
            }

            console.log(this.$validate(dataKeys));

            this.$validate(dataKeys).then((success) => {
                if (!success) {
                    this.errorAlert('필수데이터를 확인해주세요.');
                    util.Array.each(this.writeLayouts, (layout, index, arr) => {
                        EventBus.$emit(`${layout}Validator`);
                    })
                    return false;
                }

                this.changeLoading(true);
                let params = JSON.parse(JSON.stringify(this.writeApiParamSet))
                dataKeys = Object.keys(this.parsingData);
                dataKeys.forEach(dataKey => {
                    params[this.parsingData[dataKey]] = this[dataKey];
                })
                if (this.liveKlassKey !== 0) {
                    params[this.keyName] = this.liveKlassKey;
                }
                if(this.url === '' && params.hasOwnProperty('lk_url')) {
                    params.lk_url = '';
                }
                try {
                    this.$api.$liveklass[this.writeFunc](params).then(res => res.Data.Result).then(res => {
                        let type = this.returnLiveKlassWriteType(res.Info.type);
                        if (type != true) {
                            this.errorAlert(type);
                            this.changeLoading(false);
                            return false;
                        }
                        if (!util.isEmpty(this.deleteFiles)) {
                            this.removeFiles(this.deleteFiles)
                        }

                        let checkFile =
                            !util.isEmpty(this.fileType) &&
                            !util.isEmpty(this.files) &&
                            this.files.filter((file) => file.hasOwnProperty("raw")).length >
                            0;
                        if (!util.isEmpty(this.fileType) && !util.isEmpty(this.files) && checkFile) {
                            for (let i = 0; i < this.files.length; i++) {
                                this.files[i].a_seq = i;
                            }
                            let uploadFileList = this.files;
                                                        // let uploadFileList = this.files.filter(item => !item.a_idx);
                            let file_id = "";
                            file_id = this.liveklassType === "liveKlassDetail"  ? this.liveKlassKey  : res.List;
                            console.log("!uploadFileList",uploadFileList,file_id);
                            this.uploadFiles(uploadFileList, this.fileType, file_id).then(success => {
                            });
                            this.afterFunc(res.List);
                        } else {
                            this.afterFunc(res.List);
                        }
                    })
                } catch (e) {
                    this.changeLoading(false);
                    console.log(e)
                }
            })
        },
        afterFunc(key) {
            this.changeLoading(false);
            if (this.liveKlassKey != 0) {
                EventBus.$emit('liveKlassListUpdateAfterFunc', this.keyName, Number(this.liveKlassKey));
            } else {
                EventBus.$emit('liveKlassListAddAfterFunc');
            }
            let detailKey = key;
            this.createAlert({
                title: '',
                content: '저장되었습니다.',
                btnText: '확인',
                hide: () => {
                    if (this.directType === 'back') {
                        this.$router.back();
                        return false;
                    }
                    if (this.directUrl === '') {
                        this.writeLayouts = [];
                        this.deleteFiles = [];
                        this.getLiveKlass();
                        this.$router.back();
                        return false;
                    }
                    let url = this.directUrl;
                    if (this.directType === 'detail') {
                        url = url + detailKey;
                    }
                    this.$router.push(url);
                }
            })
        },
        returnLiveKlassWriteType(type) {
            switch (type) {
                case 1:
                    return true;
                case -107:
                    return "동일한 진행자명이 존재합니다.";
                    break;
                case -108:
                    return "이미 등록된 샘샘즈입니다.";
                    break;
                case -109:
                    return "미사용중인 샘샘즈입니다.";
                    break;
                default:
                    return "라이브 클래스 등록에 실패하였습니다.";
            }
        },
        runDeleteConfirm() {
            if (util.isEmpty(this.deleteAlertText)) {
                this.runDelete();
            } else {
                this.createConfirm({
                    content: this.deleteAlertText,
                    confirmButtonText:"삭제",
                    confirm: () => {
                        this.runDelete();
                    }
                })
            }
        },
        runDelete() {
            this.changeLoading(true);
            this.DeleteClass.runDelete(this.liveKlassKey);
        },
        deleteAfterFunc() {
            this.createAlert({
                content: this.deleteSuccessAlertText,
                hide: () => {
                    this.changeLoading(false);
                    this.$router.push('/content/liveklass');
                    // this.$router.back();
                },
            })
        },
    },
    watch: {},
}
</script>

<style scoped>

</style>
